/* Très simple i18n (FR par défaut + lingala partiel à valider par un locuteur). */
import { en, nl, SPEECH_LANG } from "./i18n_eu";

export const dict = {
  fr: {
    app_name: "Bombacare Connect",
    tagline: "Reprenez votre vie en main, jour après jour",
    online: "En ligne — à jour",
    offline_count: (n) => `Hors ligne — ${n} élément(s) enregistré(s) · tout fonctionne`,
    syncing: "Synchronisation…",
    nav_home: "Accueil",
    nav_exercises: "Exercices",
    nav_health: "Ma santé",
    nav_comm: "Communiquer",
    nav_profile: "Profil",
    mode_patient: "Patient",
    mode_aidant: "Aidant",
    aidant_banner: "Mode Aidant : les consignes vous guident pour aider votre proche.",
    program_today: "Mon programme du jour",
    task_exercise: "Séance de rééducation",
    task_meds: "Médicaments",
    task_bp: "Mesure de tension",
    task_mood: "Comment je vais",
    quick_access: "Accès rapide",
    word_book: "Carnet de mots",
    avc_explained: "L'AVC expliqué",
    prevention_title: "Prévention de la récidive",
    prevention_body: "Contrôler la tension et bien prendre ses traitements réduit fortement le risque de récidive.",
    level: "Niveau",
    points: "points",
    streak: "jours d'affilée",
    domains: "Domaines thérapeutiques",
    balance_memory: "Équilibre & mémoire",
    walk_balance: "Marche & équilibre",
    daily_gestures: "Gestes du quotidien",
    start: "Commencer",
    next: "Suivant",
    listen: "Écouter",
    finish: "Terminer",
    bravo: "Bravo !",
    plus_points: "+120 points",
    saved_offline: "Enregistré — sera envoyé au retour du réseau.",
    bp_journal: "Journal de tension",
    bp_target: "Cible fixée avec votre médecin",
    bp_in: "Dans la cible",
    bp_watch: "À surveiller",
    bp_high: "Élevée",
    bp_sys: "Systolique",
    bp_dia: "Diastolique",
    bp_save: "Enregistrer la mesure",
    bp_no_advice: "Ceci n'est pas un avis médical. Parlez à votre soignant en cas de doute.",
    meds_adherence: "Observance des médicaments",
    mark_taken: "Marquer comme pris",
    taken: "Pris",
    adherence: "Observance",
    mood: "Comment je vais",
    mood_low_msg: "Les baisses de moral sont fréquentes après un AVC. Ce n'est pas une faiblesse.",
    alert_team: "Prévenir mon équipe de soin",
    matin: "Matin", midi: "Midi", soir: "Soir",
    word_grid_title: "Touchez les images pour former une phrase",
    announce: "Annoncer",
    clear: "Effacer",
    messages: "Messages",
    message_placeholder: "Écrire à mon équipe…",
    send: "Envoyer",
    next_appt: "Prochain rendez-vous",
    teleconsult: "Téléconsultation",
    in_person: "Présentiel",
    profile: "Profil",
    language: "Langue",
    french: "Français",
    lingala: "Lingala",
    logout: "Se déconnecter",
    sync_now: "Synchroniser maintenant",
    sync_done: "Tout est à jour",
    welcome: "Bienvenue",
    login: "Se connecter",
    register: "Créer un compte",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom complet",
    phone: "Téléphone",
    role: "Je suis…",
    role_patient: "Patient",
    role_aidant: "Aidant familial",
    role_therapeute: "Praticien",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    create: "Créer mon compte",
    login_failed: "Connexion impossible",
    words: {
      pain: "Douleur", hunger: "Faim", thirst: "Soif", toilet: "Toilettes",
      tired: "Fatigué", med: "Médicament", yes: "Oui", no: "Non",
      thanks: "Merci", help: "Aide",
    },
  },
  ln: {
    app_name: "Bombacare Connect",
    tagline: "Zonga na bomoi na yo, mokolo na mokolo",
    online: "Na ligne — to mises",
    offline_count: (n) => `Lokóla offline — biloko ${n} ebombami · esalaka`,
    syncing: "Kotinda ba ndimbola…",
    nav_home: "Ndako", nav_exercises: "Ba exercises", nav_health: "Nzoto na ngai",
    nav_comm: "Koloba", nav_profile: "Profil",
    mode_patient: "Mobeli", mode_aidant: "Mosalisi",
    aidant_banner: "Mode Mosalisi : ba mibeko mpo na kosalisa ndeko na yo.",
    program_today: "Programme ya lelo",
    task_exercise: "Ba exercises", task_meds: "Ba nkisi",
    task_bp: "Tension", task_mood: "Ndenge nayoki",
    quick_access: "Bondéle nokinoki",
    word_book: "Buku ya maloba", avc_explained: "AVC elimbolami",
    prevention_title: "Kopekisa kobongwana", prevention_body: "Kotala tension mpe komela nkisi ekitisaka risque.",
    level: "Niveau", points: "ba points", streak: "ba mikolo molongo",
    domains: "Ba domaines",
    balance_memory: "Équilibre & mémoire", walk_balance: "Kotambola & équilibre",
    daily_gestures: "Misala ya mokolo",
    start: "Banda", next: "Esuivre", listen: "Yoka", finish: "Sukisa",
    bravo: "Malamu mingi !", plus_points: "+120 ba points",
    saved_offline: "Ebombami — tokotinda tango réseau ekozonga.",
    bp_journal: "Cahier ya tension", bp_target: "Cible esalemi na monganga",
    bp_in: "Na cible", bp_watch: "Tala malamu", bp_high: "Likolo",
    bp_sys: "Systolique", bp_dia: "Diastolique", bp_save: "Bomba mesure",
    bp_no_advice: "Ezali avis ya monganga te. Loba na monganga soki ozali na motuna.",
    meds_adherence: "Komela ba nkisi", mark_taken: "Namelaki", taken: "Emelami",
    adherence: "Komela", mood: "Ndenge nayoki",
    mood_low_msg: "Mawa ezalaka mingi sima ya AVC. Ezali bolembu te.",
    alert_team: "Yebisa équipe ya soins",
    matin: "Tongo", midi: "Midi", soir: "Mpokwa",
    word_grid_title: "Simba ba image mpo na kosala phrase",
    announce: "Loba", clear: "Longola",
    messages: "Ba messages", message_placeholder: "Koma na équipe na ngai…",
    send: "Tinda",
    next_appt: "Rendez-vous mosusu", teleconsult: "Téléconsultation", in_person: "Présentiel",
    profile: "Profil", language: "Lokota", french: "Falanse", lingala: "Lingala",
    logout: "Bima", sync_now: "Sync sik'oyo", sync_done: "Nyonso ezali na mises",
    welcome: "Boyei malamu",
    login: "Kota", register: "Sala compte",
    email: "E-mail", password: "Mot de passe", name: "Kombo mobimba",
    phone: "Téléphone", role: "Ngai nazali…",
    role_patient: "Mobeli", role_aidant: "Mosalisi", role_therapeute: "Praticien",
    no_account: "Ozali na compte te ?", have_account: "Ozali na compte ?",
    create: "Sala compte na ngai", login_failed: "Connexion ekoki te",
    words: {
      pain: "Mpasi", hunger: "Nzala", thirst: "Mposa ya mai", toilet: "Toilettes",
      tired: "Nalembi", med: "Nkisi", yes: "Ee", no: "Te",
      thanks: "Matondi", help: "Lisalisi",
    },
  },
};

dict.en = en;
dict.nl = nl;

export function t(lang, key, ...args) {
  const lng = dict[lang] ? lang : "fr";
  const segs = key.split(".");
  let cur = dict[lng];
  for (const s of segs) cur = cur?.[s];
  if (cur == null) { cur = dict.fr; for (const s of segs) cur = cur?.[s]; }
  if (typeof cur === "function") return cur(...args);
  return cur;
}

export const LANGS = [
  { code: "fr", label: "Français", regions: ["afrique", "europe"] },
  { code: "ln", label: "Lingala", regions: ["afrique", "europe"] },
  { code: "en", label: "English", regions: ["europe"] },
  { code: "nl", label: "Nederlands", regions: ["europe"] },
];
export const langsFor = (region) => LANGS.filter((l) => l.regions.includes(region || "afrique"));

export function speak(text, lang) {
  if (!("speechSynthesis" in window) || !text) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = SPEECH_LANG[lang] || "fr-FR"; // lingala TTS rarely available → voix française
    u.rate = 0.95;
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* ignore */
  }
}
